import React from 'react';
import { Loader2, Lightbulb } from 'lucide-react';
import type { BaseCropComponentProps } from '../types';
import { useCropStore } from '../store/cropStore';
import { button } from '../styles/index';

interface CropControlsProps extends BaseCropComponentProps {
  onClose: () => void;
  onApply: () => void;
  isLoading?: boolean;
  cancelLabel?: string;
  applyLabel?: string;
  zoomTipLabel?: string;
}

export const CropControls: React.FC<CropControlsProps> = ({
  onClose,
  onApply,
  isLoading = false,
  cancelLabel = 'Cancel',
  applyLabel = 'Apply Crop',
  zoomTipLabel,
  className,
}) => {
  const { hasSelection, isSubmitting } = useCropStore();
  const isDisabled = !hasSelection() || isLoading || isSubmitting;
  const isCancelDisabled = isLoading || isSubmitting;
  const showSpinner = isLoading || isSubmitting;

  return (
    <div
      className={`flex items-center justify-between flex-1 sm:flex-row flex-col gap-3 ${className || ''}`}
    >
      {/* Zoom tip with icon */}
      <div className="flex items-center gap-2 text-sm text-gray-400 sm:justify-start justify-center">
        <Lightbulb className="h-4 w-4 text-yellow-400" />
        <span>{zoomTipLabel}</span>
      </div>

      {/* Action buttons */}
      <div className="flex items-center gap-3 sm:flex-row flex-col sm:w-auto w-full">
        <button
          className={`${button('secondary', isCancelDisabled)} sm:w-auto w-full justify-center`}
          onClick={onClose}
          disabled={isCancelDisabled}
        >
          {cancelLabel}
        </button>

        <button
          className={`${button('primary', isDisabled)} sm:w-auto w-full justify-center`}
          onClick={onApply}
          disabled={isDisabled}
        >
          {showSpinner && <Loader2 className="animate-spin h-4 w-4 mr-2" />}
          {applyLabel}
        </button>
      </div>
    </div>
  );
};
